import { Component, inject, OnInit } from '@angular/core';
import { GenericStreamsService } from '../../../service/generic-streams.service';
import { MatDialogRef } from '@angular/material/dialog';
import { environmentMode } from '../../../../environments/environment';

@Component({
    selector: 'app-add-ressource',
    standalone: false,
    templateUrl: './add-ressource.component.html',
    styleUrl: './add-ressource.component.scss'
})
export class AddRessourceComponent implements OnInit {

    genService = inject(GenericStreamsService);
    dialog = inject(MatDialogRef<AddRessourceComponent>)
    name: string | undefined;
    url: URL | undefined;
    isLodaing: boolean = false;
    responseJson: any | undefined;

    ngOnInit(): void {
        if ((environmentMode) === "local") {
            this.name = "Landingpage";
            this.url = new URL("https://track-frill-64698362.figma.site/");
        }
    }

    async startextraction() {
        if (!this.name || !this.url) {
            return
        }
        this.isLodaing = true;
        let result = await this.genService.extractFigmaSite(this.name, this.url);
        this.isLodaing = false;
        if (result === false) {
            return;
        }

        this.responseJson = [result]


    }

    close() {
        this.dialog.close();
    }
}
